// extracted by mini-css-extract-plugin
export default {"authLayout":"index_authLayout__94xZv","logo":"index_logo__sFB14"};